import { DesignData, Spread } from 'editor/src/store/design/types';

import { elementUuids, conditionUuids, conditionOptionUuids } from 'editor/src/util/uuids';

// seeding the counter beyond this would risk reaching Number.MAX_SAFE_INTEGER, where `uuid += 1`
// stops advancing and every generated id would be identical
const MAX_SEED = 1e9;

// condition and option ids are stringified counter values, ids from other sources are ignored
function maxUuid(current: number, id: string) {
  const parsed = parseInt(id, 10);
  return Number.isSafeInteger(parsed) && parsed <= MAX_SEED ? Math.max(current, parsed) : current;
}

function setupUuidGenerators(designDataItems: DesignData[]) {
  let elementMaxUuid = 1;
  let conditionMaxUuid = 1;
  let valueMaxUuid = 1;
  let hasMissingUuids = false;

  const extractMaxUuids = (spread: Spread) => {
    const group = spread.conditionGroup;
    if (group) {
      Object.keys(group.conditions).forEach((conditionId) => {
        conditionMaxUuid = maxUuid(conditionMaxUuid, conditionId);
        group.conditions[conditionId]?.options?.forEach((option) => {
          valueMaxUuid = maxUuid(valueMaxUuid, option.id);
        });
      });
    }

    spread.pages.forEach((page) => {
      page.groups.media?.forEach((mediaElement) => {
        if (mediaElement.uuid) {
          elementMaxUuid = Math.max(elementMaxUuid, mediaElement.uuid);
        } else {
          hasMissingUuids = true;
        }
      });
    });
  };

  designDataItems.forEach((designData) => designData.spreads.forEach(extractMaxUuids));

  // we should guarantee that we don't reduce generator value for ecomm flow
  elementMaxUuid >= elementUuids.getCurrent() && elementUuids.setup(elementMaxUuid);
  conditionMaxUuid >= conditionUuids.getCurrent() && conditionUuids.setup(conditionMaxUuid);
  valueMaxUuid >= conditionOptionUuids.getCurrent() && conditionOptionUuids.setup(valueMaxUuid);

  if (hasMissingUuids) {
    const applyMaxUuids = (spread: Spread) => {
      spread.pages.forEach((page) => {
        page.groups.media?.forEach((mediaElement) => {
          if (!mediaElement.uuid) {
            mediaElement.uuid = elementUuids.generate();
          }
        });
      });
    };

    designDataItems.forEach((designData) => designData.spreads.forEach(applyMaxUuids));
  }
}

export default setupUuidGenerators;
